import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
// istanbul ignore next
const FilterCondition = loadable(() => import('../../Filter/FilterCondition'));
import { useCollapsibleState } from '../FilterHelpers/useSRPFilters';
import loadable from '@loadable/component';

const CollapsibleCondition = ({facetConfig, label, condition, handleDataChange, tracking, position, params}) => {
  const { isEnabled, isOpen } = useCollapsibleState('condition', facetConfig);
  if (!isEnabled) {
    return null;
  }
  return (
    <CollapsibleContent initialState={isOpen}>
      <CollapsibleHeader priority={0}>
        {label}
      </CollapsibleHeader>
      <Collapsible>
        <FilterCondition
          position={position}
          condition={condition}
          handleDataChange={handleDataChange}
          tracking={tracking}
          id={`filter-condition-${position}`}
          params={params}
        />
      </Collapsible>
    </CollapsibleContent>
  );
};
CollapsibleCondition.propTypes = {
  context: PropTypes.object,
  facetConfig: PropTypes.array,
  data: PropTypes.object,
  handleDataChange: PropTypes.func,
  tracking: PropTypes.object,
  position: PropTypes.string,
  params: PropTypes.object,
  condition: PropTypes.string,
  label: PropTypes.string,
};

export { CollapsibleCondition };
